const MailchimpPlaceholders = () => {
  const mailchimpFormFields = document.querySelector(".mc4wp-form-fields");
  
  if (mailchimpFormFields) {
    const firstNameInput = mailchimpFormFields.querySelector("input[name='FIRSTNAME']");
    const lastNameInput = mailchimpFormFields.querySelector("input[name='LASTNAME']");
    const companyInput = mailchimpFormFields.querySelector("input[name='COMPANY']");
    const emailInput = mailchimpFormFields.querySelector("input[name='EMAIL']");
    const phoneInput = mailchimpFormFields.querySelector("input[name='Phone']")

    if (firstNameInput) {
      firstNameInput.placeholder = "First name*";
    }

    if (lastNameInput) {
      lastNameInput.placeholder = "Last name*";
    }

    if (companyInput) {
      companyInput.placeholder = "Company*"
    }

    if (emailInput) {
      emailInput.placeholder = "E-mail address*"
    }

    if (phoneInput) {
      phoneInput.placeholder = "Phone number*"
    }
  }
  
}

export default MailchimpPlaceholders;